/* =========================================================
   Heatronics - CAT-01. The heat-therapy guide block at the
   foot of every collection lander is 2,698 characters of real
   copy and 30.3% of the mobile page. It is worth keeping and
   not worth 835px of unbroken scroll, so it is clamped to
   320px behind a disclosure.

   CSS-only clamping would have hidden the copy for good -
   this adds the control that opens it. Styling lives in
   assets/ui-consistency.css under CAT-01.

   Picking the right element matters: the section's first
   child is a .section-background paint layer with no copy in
   it. Clamping that did nothing except add a button. So the
   target is chosen by which child actually holds the text.

   Remove the <script> line in snippets/stylesheets.liquid to
   switch it off; the block returns to full height.
   ========================================================= */

(function () {
  var SEL = '[id*="custom_liquid_AAtMeH"]';
  var LABEL_MORE = 'Read the full guide';
  var LABEL_LESS = 'Show less';
  var CLAMP_AT = 420;

  /* The child with the most text, ignoring paint layers. */
  function contentEl(sec) {
    var best = null, bestLen = 0;
    var kids = sec.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.tagName === 'STYLE' || k.tagName === 'SCRIPT') continue;
      if (/section-background/.test(String(k.className))) continue;
      var clone = k.cloneNode(true);
      var drop = clone.querySelectorAll('style,script');
      for (var j = 0; j < drop.length; j++) drop[j].remove();
      var len = (clone.textContent || '').replace(/\s+/g, ' ').trim().length;
      if (len > bestLen) { bestLen = len; best = k; }
    }
    return bestLen > 300 ? best : null;
  }

  function build(sec) {
    if (sec.getAttribute('data-hb-clamp') === '1') return;

    var body = contentEl(sec);
    if (!body) return;
    /* Only clamp when there is genuinely more than the clamp height,
       otherwise the control is noise. */
    if (body.getBoundingClientRect().height < CLAMP_AT) return;

    sec.setAttribute('data-hb-clamp', '1');
    body.classList.add('hb-clamp');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hb-more';
    btn.textContent = LABEL_MORE;
    btn.setAttribute('aria-expanded', 'false');
    body.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      btn.textContent = open ? LABEL_LESS : LABEL_MORE;
      btn.setAttribute('aria-expanded', String(open));
      if (!open) body.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }

  function scan() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) build(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* images inside the block settle late and change its height */
  window.addEventListener('load', scan);
})();
